// extracted by mini-css-extract-plugin
export default {"dosageQuantityInput":"DosageQuantityInput_dosageQuantityInput__2WzUm","dosageQuantityInfoIcon":"DosageQuantityInput_dosageQuantityInfoIcon__7+nF9"};